import { getPartnerDetails } from '../utils/helper'
// import { getUserSecret } from './secrets'

export const getConfigDetails = () => {

  //Get the partner
  // const user = window.location.toString().split('/')[3]

  // switch ('demo') {
  // switch ('preStage') {
  // switch ('staging') {
  // switch ('preprod') {
    switch ('live') {
    case 'demo': //staging2
      return {
        baseURL: 'https://demo-api.parkengage.com/',
        adminUrl: 'https://demo-admin.parkengage.com',
        transientURL: 'https://demo-transient.parkengage.com',
        checkInUrl: 'https://demo-checkin.parkengage.com',
        portalURL: 'https://demo-customerportal.parkengage.com/navigating',
        // portalURL: 'http://localhost:3000/navigating',
        FACILITY_ID: 1,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
    case 'preStage': //staging
      return {
        baseURL: 'https://pre-stage-api.parkengage.com/',
        adminUrl: 'https://pre-stage-admin.parkengage.com',
        checkInUrl: 'https://pre-stage-checkin.parkengage.com',
        transientURL: 'https://pre-stage-transient.parkengage.com',
        portalURL: 'https://pre-stage-customerportal.parkengage.com/navigating',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
    case 'staging': //staging
      return {
        baseURL: 'https://staging-api.parkengage.com/',
        adminUrl: 'https://staging-admin.parkengage.com',
        checkInUrl: 'https://staging-checkin.parkengage.com',
        transientURL: 'https://staging-transient.parkengage.com',
        portalURL: 'https://staging-customerportal.parkengage.com/navigating',

        revadminUrl: 'https://staging-backoffice.rev-pass.com',
        revcheckInUrl: 'https://staging-checkin.rev-pass.com',
        revtransientURL: 'https://staging-transient.rev-pass.com',
        revportalURL: 'https://staging-customerportal.rev-pass.com/navigating',

        pciAdminUrl: 'https://staging.adminportal.breezeparking.com',
        pciCheckInUrl: 'https://staging-checkin.breezeparking.com',
        pciTransientURL: 'https://staging-pci.breezeparking.com',
        pciPortalURL: 'https://staging-customerportal.breezeparking.com/navigating',

        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
    case 'preprod': //staging
      return {
        baseURL: 'https://preprod-api.parkengage.com/',
        adminUrl: 'https://preprod-admin.parkengage.com',
        checkInUrl: 'https://preprod-checkin.parkengage.com',
        transientURL: 'https://preprod-transient.parkengage.com',
        portalURL: 'https://preprod-customerportal.parkengage.com/navigating',

        revadminUrl: 'https://preprod-backoffice.rev-pass.com',
        revcheckInUrl: 'https://preprod-checkin.rev-pass.com',
        revtransientURL: 'https://preprod-transient.rev-pass.com',
        revportalURL: 'https://preprod-customerportal.rev-pass.com/navigating',


        pciAdminUrl: 'https://preprod-pciadmin.parkengage.com',
        pciCheckInUrl: 'https://preprod-pcicheckin.parkengage.com',
        pciTransientURL: 'https://preprod-pcitransient.parkengage.com',
        pciPortalURL: 'https://preprod-pcicustomerportal.parkengage.com/navigating',
        
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
    case 'live': //live
      return {
        baseURL: 'https://api.parkengage.com/',
        adminUrl: 'https://partner.parkengage.com',
        checkInUrl: 'https://checkin.parkengage.com',
        transientURL: 'https://transient.parkengage.com',
        portalURL: 'https://customerportal.parkengage.com/navigating',

        // Rev Pass URL
        revadminUrl: 'https://backoffice.rev-pass.com',
        revcheckInUrl: 'https://checkin.rev-pass.com',
        revtransientURL: 'https://transient.rev-pass.com',
        revportalURL: 'https://customerportal.rev-pass.com/navigating',

        pciAdminUrl: 'https://adminportal.breezeparking.com',
        pciCheckInUrl: 'https://checkin.breezeparking.com',
        pciTransientURL: 'https://pci.breezeparking.com',
        pciPortalURL: 'https://customerportal.breezeparking.com/navigating',

        FACILITY_ID: 32,
        FULL_SEASON: '80',
        HALF_SEASON: '81',
        SIX_PACK: '82',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
    case 'mob': //mob
      return {
        baseURL: 'https://api-mob.parkengage.com/',
        adminUrl: 'https://partner-mob.parkengage.com',
        checkInUrl: 'https://checkin-mob.parkengage.com',
        transientURL: 'https://transient-mob.parkengage.com',
        portalURL: 'https://customerportal-mob.parkengage.com/navigating',

        // Rev Pass URL
        revadminUrl: 'https://backoffice.rev-pass.com',
        revcheckInUrl: 'https://checkin.rev-pass.com',
        revtransientURL: 'https://transient.rev-pass.com',
        revportalURL: 'https://customerportal.rev-pass.com/navigating',


        FACILITY_ID: 32,
        FULL_SEASON: '80',
        HALF_SEASON: '81',
        SIX_PACK: '82',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
  }
}
